import { EmailField, StringField } from '@src/permitField/PermitFields';
import type { StringSchema } from 'yup';
import * as yup from 'yup';

export class UserEmailFields extends EmailField {
  public static fieldName: string = 'userEmail';
}

export class PasswordResetCode extends StringField {
  public static fieldName: string = 'passwordResetCode';
}

export class PasswordField extends StringField {
  public static fieldName: string = 'password';
  public static validator: StringSchema = yup
    .string()
    .trim()
    .required('isPassword')
    .matches(/[A-Z]/, { message: 'isPassword' })
    .matches(/[a-z]/, { message: 'isPassword' })
    .matches(/[1-9]/, { message: 'isPassword' })
    .matches(/[!@#$%^&*(),.?":{}|<>]/, { message: 'isPassword' })
    .min(8);
}

export class ConfirmPasswordField extends StringField {
  public static fieldName: string = 'confirmPassword';
}

export const ConfirmResetPasswordPageSchema = yup.object().shape({
  [UserEmailFields.fieldName]: UserEmailFields.validator as StringSchema<
    NonNullable<string>
  >,
  [PasswordResetCode.fieldName]: PasswordResetCode.validator as StringSchema<
    NonNullable<string>
  >,
  [PasswordField.fieldName]: PasswordField.validator as StringSchema<
    NonNullable<string>
  >,
  [ConfirmPasswordField.fieldName]: yup
    .string()
    .required('isPassword')
    .oneOf([yup.ref(PasswordField.fieldName)], 'passwordsMustMatch'),
});
